// Mutations
export const CHANGE_GRAPH_STATE = "CHANGE_GRAPH_STATE";
export const SIGNIN_GRAPH_SUCCESS = "SIGNIN_GRAPH_SUCCESS";
export const SIGNIN_GRAPH_FAILED = "SIGNIN_GRAPH_FAILED";
export const SIGNOUT_GRAPH_SUCCESS = "SIGNOUT_GRAPH_SUCCESS";
export const SIGNOUT_GRAPH_FAILED = "SIGNOUT_GRAPH_FAILED";

// Actions
export const SIGNIN_GRAPH_REQUEST = "SIGNIN_GRAPH_REQUEST";
export const SIGNOUT_GRAPH_REQUEST = "SIGNOUT_GRAPH_REQUEST";
